import React from 'react'
import { Vortex } from 'react-loader-spinner'

const Loader = () => {
  return (
    <div className='loader'>

        <div>
            <h1 id='loaderHeader'>Gara-Innov</h1>
        </div>
     
     <div>
     <Vortex
  visible={true}
  height="100"
  width="100"
  ariaLabel="vortex-loading"
  wrapperStyle={{}}
  wrapperClass="vortex-wrapper"
  colors={['#228B22', '#228B22','#228B22','#228B22','#228B22','#228B22']}
/>
     </div>
    </div>
  )
}

export default Loader
